module.exports = __webpack_public_path__ + "img/coupon_ysx.be83f76b.svg";